<div class="packagesDestinationMobile__cont">
  <div class="packagesDestinationMobile__cont__departure">
    <app-ds-input-text
      [isReadonly]="true"
      [icon]="iconStarPoint"
      [label]="'SEARCH_MODULE.LOCATION_SEARCH.FROM' | transloco"
      [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_ORIGIN_MOBILE' | transloco"
      [value]="departurePlace?.NameFull"
      [isFailed]="departureInputHasAnError"
      [failedMessage]="'SEARCH_MODULE.LOCATION_SEARCH.SELECT_ORIGIN_ERROR' | transloco"
      (clickEvent)="toggleAutocompleteView(false)">
    </app-ds-input-text>
  </div>
  <div class="packagesDestinationMobile__swipe-locations">
    <app-ds-button-icon
      [buttonSize]="buttonIconSize"
      [icon]="arrowIcon"
      (clickEvent)="swipePlaces()">
    </app-ds-button-icon>
  </div>
  <div class="packagesDestinationMobile__cont__destination">
    <app-ds-input-text
      [isReadonly]="true"
      [icon]="iconLocation"
      [label]="'SEARCH_MODULE.LOCATION_SEARCH.TO' | transloco"
      [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION_MOBILE' | transloco"
      [value]="destinationInputValue"
      [isFailed]="destinationInputHasAnError"
      [failedMessage]="destinationInputError | transloco"
      (clickEvent)="toggleAutocompleteView(true)">
    </app-ds-input-text>
  </div>

  <app-packages-destination-autocomplete
    [searchType]="searchType"
    [placeType]="placeType"
    [query]="query"
    [viewAutocomplete]="viewAutocomplete"
    [isDestinationSelected]="isDestinationSelected"
    [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
    [cityAndAirportsAutocomplete]="cityAndAirportsAutocomplete"
    [hotelAndLocationsAutocomplete]="hotelAndLocationsAutocomplete"
    (closeAutocomplete)="close()"
    (setQuery)="setQuery($event)"
    (popularAmplitudeEvent)="popularAmplitudeEvent.emit($event)"
    (selectAirportOrCityEvent)="selectAirportOrCity($event)"
    (selectLocationEvent)="selectLocation($event)"
    (selectHotelEvent)="selectHotel($event)"
    (selectPopularPlace)="selectPopularPlaceTrigger($event)">
  </app-packages-destination-autocomplete>
  
</div>

